export default __webpack_public_path__ + "static/media/capture.309b8232.svg";